import { render, staticRenderFns } from "./delete-file.vue?vue&type=template&id=4f6b7dbf&scoped=true&"
import script from "./delete-file.vue?vue&type=script&lang=js&"
export * from "./delete-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6b7dbf",
  null
  
)

export default component.exports